import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import cryptoRandomString from 'crypto-random-string';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { MultiSelect } from "primereact/multiselect";

const EditableModal = ({
  isEditModalOpen,
  closeEditModal,
  selectedItem,
  handleUpdate,
  setSelectedItem,
  columnList,
  showPassword = false,
  setShowPassword,
}) => {
  const [passwordError, setPasswordError] = useState("");

  const validatePassword = (password) => {
    if (password?.length < 8) {
      setPasswordError("Password must have at least 8 characters");
    } else {
      setPasswordError("");
    }
  };

  const mapSelectedEmailsToOptions = (selectedEmails) => {
    return selectedEmails.map(email => (email));
  };
  return (
    <Modal isOpen={isEditModalOpen} toggle={closeEditModal} className="edit-modal">
      <ModalHeader toggle={closeEditModal} className="modal-header">
        Edit Details
      </ModalHeader>
      <ModalBody className="modal-body">
        {selectedItem && (
          <form onSubmit={handleUpdate}>
            {columnList?.map(({ label, field }, index) =>
              label && label !== "Action" ? ( // Exclude the Action field here
                <div className="form-group" key={index}>
                  <label
                    id="apiKey"
                    style={{ width: "150px", marginTop: 11, fontSize: 14 }}
                  >
                    {label}
                  </label>

                  { field === "password" ? (
                    <span style={{ borderColor: '#4b38b3', borderWidth: 2, flexDirection: 'column', width: '76.7%' }}>
                      <input
                        disabled={field === "type" || field === "_id"}
                        type={showPassword ? "text" : "password"}
                        style={{ height: '37px' }}
                        value={selectedItem[field !== "password" ? field : null]}
                        onChange={(e) => {
                          setSelectedItem({
                            ...selectedItem,
                            [field]: e.target.value,
                          });
                          validatePassword(e.target.value);
                        }}
                      />
                      {field === "password" && (
                        <button
                          className="btn btn-link position-absolute end-0 text-decoration-none text-muted"
                          type="button"
                          id="password-addon"
                          style={{ marginRight: '12px' }}
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? (
                            <i className="ri-eye-off-fill align-middle m-44"></i>
                          ) : (
                            <i className="ri-eye-fill align-middle bg-amber-100"></i>
                          )}
                        </button>
                      )}
                      {passwordError && (
                        <div style={{ color: "red" }}>{passwordError}</div>
                      )}
                    </span>
                  ) : field === "role" ? (
                    <select
                      className="form-control"
                      value={selectedItem[field] || ""}
                      onChange={(e) => setSelectedItem({
                        ...selectedItem,
                        [field]: e.target.value,
                      })}
                      style={{ width: "75%" }}
                    >
                      <option value="" disabled>Select Role</option>
                      <option value="admin">Admin</option>
                      <option value="user">User</option>
                      <option value="superadmin">Super Admin</option>
                      <option value="viewuser">View User</option>
                    </select>
                  ) : (
                    <input
                      disabled={field === "type" || field === "_id"}
                      type="text"
                      className="form-control"
                      value={selectedItem[field]}
                      onChange={(e) => setSelectedItem({
                        ...selectedItem,
                        [field]: e.target.value,
                      })}
                    />
                  )}
                </div>
              ) : null
            )}

            <div className="text-center"style={{display:'flex', justifyContent:'flex-end' }}>
              <button
                type="button"
                onClick={closeEditModal}
                style={{ backgroundColor: "#4b38b3", marginRight: 10, padding: "8px"}}
              >
                Cancel
              </button>
              <button type="submit" style={{ backgroundColor: "#4b38b3", padding: "8px", marginLeft: 4 }}>
                Save
              </button>
            </div>
          </form>
        )}
      </ModalBody>
    </Modal>
  );
};

export default EditableModal;
